import type { IconData } from '@stacksjs/iconify-core'

export const deepfakeTechnology1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M32 44.5v-5.163l4.668.787a3 3 0 0 0 3.488-2.706l.574-6.812c1.85-.415 3.18-1.084 4.043-1.642c.774-.5.864-1.51.348-2.274l-4.146-6.137C40.483 11.328 32.847 4 23.5 4v40.5\"/><path d=\"M3 24a3 3 0 1 0 6 0a3 3 0 1 0-6 0M8 9a3 3 0 1 0 6 0a3 3 0 1 0-6 0M7 40a3 3 0 1 0 6 0a3 3 0 1 0-6 0\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 24h14.5m0-8H18l-4.5-4.5m10 21.5H17l-4.5 4.5\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default deepfakeTechnology1
